import React, {Component} from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Form, Input, Checkbox, InputNumber, Select, Switch} from "antd";
import MenuTreeSelectModal from "../menuTreeSelectModal/MenuTreeSelectModal";
import {uuid, validateName} from "../../../../../utils";
import {message} from "../../../utils/sysManagementUtils";
import ImgUpload from "../../../paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
import BaseComponent from "../../../../../base/BaseComponent";

const FormItem = Form.Item;
const {Option} = Select;
export default class PermissionEditModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            editData: null,
            typeSelects: [
                {
                    name: "基础（兼容旧版本定制）",
                    value: "1"
                },
                {
                    name: "新页面",
                    value: "_blank"
                },
                {
                    name: "独立子系统",
                    value: "new_blank"
                },
                {
                    name: "标准",
                    value: "2"
                }
            ],
            pcOrMobile: [0],// 选中PC端或移动端
            key:""
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible && this.props.visible !== prevProps.visible) {
            if (this.props.data.clientTypes) {
                this.state.pcOrMobile = this.props.data.clientTypes
            } else {
                this.state.pcOrMobile = [0]
            }
            this.setState({
                editData: this.initData(this.props.data || {})
            });
        }
    }

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }
        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;
        //跳转方式类型配置项
        const typeSelects = eval(this.sysConfigGetValueByKey('jump_type', 'this.state.typeSelects'));
        this.state.typeSelects = typeSelects;
        let flag;//pc端 移动端显示
        let isShowType = true;//pc端显示跳转类型
        if (this.state.pcOrMobile && this.state.pcOrMobile.length === 1) {
            if (this.state.pcOrMobile.indexOf(0) > -1) {
                flag = 1;
            } else if (this.state.pcOrMobile.indexOf(1) > -1) {
                flag = 2;
                isShowType = false;
            }
        } else if (this.state.pcOrMobile.length > 1) {
            flag = 3;
        }
        // console.log('flag', flag, 'this.state.pcOrMobile.length', this.state.pcOrMobile.length);
        let path = (
            <FormItem
                label={editData.path.label}
                required={editData.path.required}
            >
                <Input
                    placeholder={editData.path.placeholder}
                    onChange={e => onDataChange({path: e.target.value})}
                    value={editData.path.value}
                />
            </FormItem>
        );
        let mobilePath = (
            <FormItem
                label={editData.mobilePath.label}
                required={editData.mobilePath.required}
            >
                <Input
                    placeholder={editData.mobilePath.placeholder}
                    onChange={e => onDataChange({mobilePath: e.target.value})}
                    value={editData.mobilePath.value}
                />
            </FormItem>
        );
        let ico = (
            <FormItem
                label={editData.ico.label}
                required={editData.ico.required}
            >
                <ImgUpload
                    isPcIcon={'PC端icon'}
                    placeholder={editData.ico.placeholder}
                    onChange={ico => onDataChange({ico})}
                    value={editData.ico.value}
                />
            </FormItem>
        );
        let mobileIco = (
            <FormItem
                label={editData.mobileIco.label}
                required={editData.mobileIco.required}
            >
                <ImgUpload
                    isPcIcon={'移动端icon'}
                    placeholder={editData.mobileIco.placeholder}
                    onChange={mobileIco => onDataChange({mobileIco})}
                    value={editData.mobileIco.value}
                />
            </FormItem>
        );
        let svg = (
            <FormItem
                label={editData.svg.label}
                required={editData.svg.required}
            >
                <Input
                    placeholder={editData.svg.placeholder}
                    onChange={e => onDataChange({svg: e.target.value})}
                    value={editData.svg.value}
                />
            </FormItem>
        );
        let mobileSvg = (
            <FormItem
                label={editData.mobileSvg.label}
                required={editData.mobileSvg.required}
            >
                <Input
                    placeholder={editData.mobileSvg.placeholder}
                    onChange={e => onDataChange({mobileSvg: e.target.value})}
                    value={editData.mobileSvg.value}
                />
            </FormItem>
        );
        return (
            <CmModal
                title={isCreate ? "添加菜单" : "修改菜单"}
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                destroyOnClose={true}
                onScrollSelect={()=>{
                    this.setState({
                        key: uuid()
                    })
                }}
            >
                <CmForm>
                    <FormItem
                        label={editData.menuName.label}
                        required={editData.menuName.required}
                    >
                        <Input
                            placeholder={editData.menuName.placeholder}
                            onChange={e => onDataChange({menuName: e.target.value})} type="text"
                            value={editData.menuName.value}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.menuCode.label}
                        required={editData.menuCode.required}
                    >
                        <Input
                            placeholder={editData.menuCode.placeholder}
                            onChange={e => onDataChange({menuCode: e.target.value})}
                            value={editData.menuCode.value}
                            disabled={!isCreate}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.fid.label}
                        required={editData.fid.required}
                    >
                        <MenuTreeSelectModal
                            flag={visible}
                            value={editData.fid.value}
                            currentId={editData.id.value}
                            checkStrictly={true}
                            onChange={value => onDataChange({fid: value})}
                            onItemDelete={id => onDataChange({fid: ""})}
                            placeholder={editData.fid.placeholder}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.clientTypes.label}
                        required={editData.clientTypes.required}
                    >
                        <Checkbox.Group
                            onChange={e => {
                                this.setState({pcOrMobile: e}, () => {
                                    onDataChange({clientTypes: e})
                                });
                            }}
                            value={editData.clientTypes.value || []}
                        >
                            <Checkbox value={0}>pc端</Checkbox>
                            <Checkbox value={1}>移动端</Checkbox>
                        </Checkbox.Group>
                    </FormItem>
                    {
                        flag === 3 ? (<>{path}{mobilePath}</>) : flag === 2 ? mobilePath : flag === 1 ? path : null
                    }
                    {
                        isShowType ? <FormItem
                            label={editData.jumpType.label}
                            required={editData.jumpType.required}
                        >
                            <Select key={this.state.key}
                                    placeholder={editData.jumpType.placeholder}
                                    value={editData.jumpType.value}
                                    style={{width: '140px'}}
                                    onChange={(value) => {
                                        this.onDataChange({jumpType: value})
                                    }}>
                                {typeSelects.map((item, i) => {
                                    return (
                                        <Option key={i} value={item.value} title={item.name}>{item.name}</Option>
                                    )
                                })}
                            </Select>
                        </FormItem> : null
                    }
                    <FormItem
                        label={editData.isExpand.label}
                        required={editData.isExpand.required}
                    >
                        <Switch
                            placeholder={editData.isExpand.placeholder}
                            checked={editData.isExpand.value}
                            unCheckedChildren='否'
                            checkedChildren='是'
                            onChange={(checked)=>this.onDataChange({isExpand:checked})}
                        />
                    </FormItem>
                    <FormItem
                        label={editData.optionSort.label}
                        required={editData.optionSort.required}
                    >
                        <InputNumber
                            placeholder={editData.optionSort.placeholder}
                            onChange={optionSort => onDataChange({optionSort})}
                            value={editData.optionSort.value || 0}
                            min={0}
                        />
                    </FormItem>
                    {
                        flag === 3 ? (<>{ico}{mobileIco}</>) : flag === 2 ? mobileIco : flag === 1 ? ico : null
                    }
                    {
                        flag === 3 ? (<>{svg}{mobileSvg}</>) : flag === 2 ? mobileSvg : flag === 1 ? svg : null
                    }
                </CmForm>
            </CmModal>
        );
    }

    enterFuc = (e) => {
        if (e.keyCode == "13") {
            this.handleOk();
        }
    };
    onDataChange = (data) => {
        // console.log('++++++++++', data);
        const editData = this.state.editData;
        let mobile = ['mobilePath', 'mobileIco', 'mobileSvg'];
        let PC = ['path', 'ico', 'svg'];
        if (this.state.pcOrMobile && this.state.pcOrMobile.length === 1) {
            if (this.state.pcOrMobile.indexOf(0) > -1) {
                Object.keys(data).forEach(key => {
                    if (mobile.indexOf(key) > -1) {
                        editData[key].value = "";
                    } else {
                        editData[key].value = data[key];
                    }
                });
            } else if (this.state.pcOrMobile.indexOf(1) > -1) {
                Object.keys(data).forEach(key => {
                    if (PC.indexOf(key) > -1) {
                        editData[key].value = "";
                    } else {
                        editData[key].value = data[key];
                    }
                });
            }
        } else {
            Object.keys(data).forEach(key => {
                editData[key].value = data[key];
            });
        }
        console.log('=======',editData);
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        let editDataKeys = Object.keys(editData);
        let mobile = ['mobilePath', 'mobileIco', 'mobileSvg'];
        let PC = ['path', 'ico', 'svg'];
        // 选择移动端时PC端传值清空
        if (this.state.pcOrMobile && this.state.pcOrMobile.length === 1) {
            if (this.state.pcOrMobile.indexOf(0) > -1) {
                editDataKeys.forEach((item, index) => {
                    if (mobile.indexOf(item) > -1) {
                        editData[item].value = "";
                    }
                });
            } else if (this.state.pcOrMobile.indexOf(1) > -1) {
                editDataKeys.forEach((item, index) => {
                    if (PC.indexOf(item) > -1) {
                        editData[item].value = "";
                    }
                });
            }
        }
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };
    initData = (
        {
            id = "",
            menuName = "",
            menuCode = "",
            path = "",
            mobilePath = "",//移动端path
            fid = "",
            clientTypes = [0],
            permissionList = [],
            optionSort = 10,
            ico = "",
            mobileIco = "",//移动端Icon
            svg = "",
            mobileSvg = "",//移动端svg
            jumpType = this.state.typeSelects[0].value,
            isExpand = false, //菜单是否自动展开
        } = {}
    ) => {
        let editData = {
            id: {
                label: "菜单名称",
                value: id,
                required: true,
                placeholder: "菜单名称"

            },
            menuName: {
                label: "菜单名称",
                value: menuName,
                required: true,
                placeholder: "请输入菜单名称",
                check: (value) => {
                    if (!value) {
                        message.error("请输入菜单名称！");
                        return false;
                    }
                    if (!validateName(value, {min: 1, max: 50},'()（）、《》')) {
                        message.error("菜单名称最多50个字符，可使用中文、数字、字母、下划线！");
                        return false;
                    }
                    return true;
                }
            },
            menuCode: {
                label: "菜单编码",
                value: menuCode,
                required: true,
                placeholder: "请输入菜单编码",
                check: (value) => {
                    if (!value) {
                        message.error("请输入菜单编码！");
                        return false;
                    }
                    if (!(/^[0-9a-zA-Z:_]{1,100}$/.test(value))) {
                        message.error("菜单编码只可填写字母、数字、下划线及冒号，限制输入100个字符！");
                        return false;
                    }
                    return true;
                }
            },
            fid: {
                label: "上级菜单",
                value: fid,
                required: true,
                placeholder: "请选择上级菜单",
                check: value => {
                    if (!value) {
                        message.error("请选择上级菜单！");
                        return false;
                    }
                    return true;
                }
            },
            clientTypes: {
                label: "客户端类型",
                value: clientTypes,
                required: true,
                placeholder: "客户端类型",
                check: (value) => {
                    if (!(value && value.length)) {
                        message.error("请输入客户端类型！");
                        return false;
                    }
                    return true;
                }
            },
            path: {
                label: "PC端路由",
                value: path,
                required: true,
                placeholder: "请输入路由地址",
                check: (value) => {
                    if (this.state.pcOrMobile && this.state.pcOrMobile.length && this.state.pcOrMobile.indexOf(0) > -1) {
                        if(!value){
                            message.error("PC端路由不能为空！");
                            return false;
                        }
                        if (!(
                            (/^(https|http):\/\//g.test(value) || /^\//g.test(value))
                            // && !(/[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|\uff0d \uff3f|\u002d]/g.test(value))
                            && !(/[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/g.test(value))
                        )) {
                            message.error("PC路由地址格式有误！");
                            return false;
                        }
                    }
                    return true;
                }
            },
            mobilePath: {
                label: "移动端路由",
                value: mobilePath,
                required: true,
                placeholder: "请输入路由地址",
                check: (value) => {
                    if (this.state.pcOrMobile && this.state.pcOrMobile.length && this.state.pcOrMobile.indexOf(1) > -1) {
                        if(!value){
                            message.error("移动端路由不能为空！");
                            return false;
                        }
                        if (!((/^(https|http):\/\//g.test(value) || /^\//g.test(value)) && !(/[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/g.test(value)))) {
                            message.error("移动端路由地址格式有误！");
                            return false;
                        }
                    }
                    return true;
                }
            },
            jumpType: {
                label: "类型",
                value: jumpType,
                required: true,
                placeholder: "请选择类型"
            },
            isExpand: {
                label: '自动展开菜单',
                value: isExpand,
                required: false,
                placeholder: "请选择是否要自动展开菜单"
            },
            permissionList: {
                label: "权限列表",
                value: permissionList,
                required: false,
                placeholder: "权限列表"
            },
            optionSort: {
                label: "排序",
                value: optionSort,
                placeholder: "排序",
                check: value => {
                    value = value ? value + "" : 0;
                    if (value.length) {
                        if (!/^\d+$/.test(value)) {
                            message.error("排序只能输入自然数！");
                            return false;
                        }
                        if (parseInt(value, 10) > 9999) {
                            message.error("排序最大为9999！");
                            return false;
                        }
                    }
                    return true;
                }
            },
            ico: {
                label: "PC端icon",
                value: ico,
                placeholder: "选择上传图标"
            },
            mobileIco: {
                label: "移动端icon",
                value: mobileIco,
                placeholder: "选择上传图标"
            },
            svg: {
                label: "PC端svg",
                value: svg,
                placeholder: "请输入svg图标"
            },
            mobileSvg: {
                label: "移动端svg",
                value: mobileSvg,
                placeholder: "请输入svg图标"
            },
        };
        return editData;
    };
}


